import { motion } from 'framer-motion';
import { Link, useParams } from 'react-router-dom';
import { BookOpen, ArrowLeft } from 'lucide-react';
import blogPosts from '../data/blogPosts';

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find(
    (p) => p.slug === slug || p.aliases?.includes(slug)
  );

  if (!post) {
    return (
      <motion.div
        className="BlogPost_notFound__SSZKi"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4 }}
      >
        <BookOpen size={42} className="BlogPost_notFoundIcon__z4UKS" />
        <h1>Article not found</h1>
        <p>The blog article you are looking for is not available.</p>
        <Link to="/blog" className="btn-primary">
          Back to Blog
        </Link>
      </motion.div>
    );
  }

  const related = blogPosts.filter((p) => p.slug !== post.slug).slice(0, 3);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <section className="BlogPost_hero__C4Ox4">
        <div className="container BlogPost_heroContainer__dFczl">
          <Link to="/blog" className="BlogPost_backLink__Lk09E">
            <ArrowLeft size={16} />
            Back to Blog
          </Link>
          <h1>{post.title}</h1>
          {post.subtitle && (
            <p className="BlogPost_subtitle__RTz9c">{post.subtitle}</p>
          )}
          <p className="BlogPost_meta__H1hsT">{post.meta}</p>
        </div>
      </section>

      <section className="section">
        <div className="container BlogPost_articleLayout__ytjvB">
          <article className="BlogPost_article__tUsVZ">
            <div
              className="BlogPost_articleContent__jiPCh"
              dangerouslySetInnerHTML={{ __html: post.contentHtml }}
            />
          </article>
          <aside className="BlogPost_sidebar__YfHsd" aria-label="Related articles">
            <h2>More Articles</h2>
            {related.map((e) => (
              <Link
                key={e.slug}
                to={`/blog/${e.slug}`}
                className="BlogPost_relatedPost__WkYBt"
              >
                <span>{e.category}</span>
                <strong>{e.title}</strong>
              </Link>
            ))}
          </aside>
        </div>
      </section>
    </motion.div>
  );
};

export default BlogPost;
